import type { ClienteItem, FiltroClientes } from "../../../services/clientesFornecedor"

export enum ClientesFornecedorActionsTypes {
    CARREGAR_RESULTADO = "CARREGAR_RESULTADO",
    ATUALIZAR_FILTRO_CAMPO = "ATUALIZAR_FILTRO_CAMPO",
    MUDAR_PAGINA = "MUDAR_PAGINA",
    LIMPAR_FILTRO = "LIMPAR_FILTRO",
}

export type ClientesFornecedorAction =
    | {
          type: ClientesFornecedorActionsTypes.CARREGAR_RESULTADO
          payload: { clientes: ClienteItem[]; total: number }
      }
    | {
          type: ClientesFornecedorActionsTypes.ATUALIZAR_FILTRO_CAMPO
          payload: { campo: keyof FiltroClientes; valor: string }
      }
    | {
          type: ClientesFornecedorActionsTypes.MUDAR_PAGINA
          payload: { pagina: number }
      }
    | {
          type: ClientesFornecedorActionsTypes.LIMPAR_FILTRO
      }
